"use client";

import React from "react";
import { IoArrowBack } from "react-icons/io5";
import {
  DollarSign,
  Briefcase,
  TrendingUp,
  Mail,
  MapPin,
  Calendar,
} from "lucide-react";

export default function WorkerDetails({ worker, onBack }) {
  return (
    <div className="bg-[#FEFEFE] min-h-screen rounded-2xl p-6">
      <div className="flex items-center gap-3 mb-8">
        <button
          onClick={onBack}
          className="p-2 hover:bg-gray-200 rounded-full transition"
        >
          <IoArrowBack className="w-6 h-6 text-gray-700" />
        </button>
        <h2 className="text-2xl font-semibold text-[#302B2B]">
          Worker Details
        </h2>
      </div>

      <div className="bg-white rounded-2xl shadow-sm p-6 flex gap-6 items-start">
        <img
          src={worker.image_url || ""}
          alt={worker.full_name}
          className="w-28 h-28 rounded-full object-cover border-4 border-[#F6F8FF]"
        />

        <div className="flex-1 flex flex-col gap-3">
          <div>
            <h3 className="text-xl font-bold text-[#302B2B]">
              {worker.full_name || "Unnamed Worker"}
            </h3>
            <p className="text-[#9A99AB] text-sm">
              {worker.bio || "No biography provided."}
            </p>
          </div>

          <div className="flex flex-wrap gap-4 mt-2 text-[#7A7A7A] text-sm">
            <div className="flex items-center gap-1">
              <Calendar className="w-4 h-4" />
              <span>Joined {worker.joined_date || "—"}</span>
            </div>
            <div className="flex items-center gap-1">
              <Mail className="w-4 h-4" />
              <span>{worker.worker_email}</span>
            </div>
            <div className="flex items-center gap-1">
              <MapPin className="w-4 h-4" />
              <span>{worker.location || "Unknown"}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4 mt-6">
        <div className="bg-white rounded-2xl p-4 text-center">
          <div className="flex items-center justify-center gap-1 text-[#4DB774]">
            <DollarSign className="w-4 h-4" />
            <span className="text-xl font-bold">
              {worker.revenue || 0}
            </span>
          </div>
          <p className="text-[#9A99AB] text-sm">Revenue</p>
        </div>

        <div className="bg-white rounded-2xl p-4 text-center">
          <div className="flex items-center justify-center gap-1 text-[#2138CF]">
            <Briefcase className="w-4 h-4" />
            <span className="text-xl font-bold">
              {worker.services_count || 0}
            </span>
          </div>
          <p className="text-[#9A99AB] text-sm">Services</p>
        </div>

        <div className="bg-white rounded-2xl p-4 text-center">
          <div className="flex items-center justify-center gap-1 text-[#F59F0A]">
            <TrendingUp className="w-4 h-4" />
            <span className="text-xl font-bold">
              $ {worker.avg_ticket || 0}
            </span>
          </div>
          <p className="text-[#9A99AB] text-sm">Avg. Ticket</p>
        </div>
      </div>

      <div className="bg-white rounded-2xl p-6 mt-6">
        <h4 className="font-semibold text-[#302B2B] text-[16px] mb-3">
          Biography
        </h4>
        <p className="text-[#7A7A7A] text-sm leading-relaxed">
          {worker.bio || "This worker has not added a biography yet."}
        </p>
      </div>
    </div>
  );
}
